import React from "react";
import ReactDOM from "react-dom/client";

import { RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "./queryClient";
import { router } from "./router";
import "./index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ""}>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider
            router={router}
            fallbackElement={
              <div className="flex justify-center items-center min-h-[calc(100vh)]">
                <span className="loading loading-spinner text-primary w-16 "></span>
              </div>
            }
          />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </SnackbarProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
